module.exports = __webpack_public_path__ + "img/LogoNew.07f498ed.svg";